import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from "../config/config";
import 'rxjs/add/operator/map';

@Injectable()
export class ScoreCardService {

  public jwtToken: string;
  constructor(private http: HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  getSubscribedCourses(user_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/getSubscribedCourses/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCourseScoreCardByLevel(course_id, level, user_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/course_scorecard/'+course_id+'/'+level+'/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getJourneyScoreCardByLevel(id, level, user_id, language_id){
    return this.http.get(Configuration.ServerWithApiUrl+'/journey_scorecard/'+id+'/'+level+'/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }
  getCompletedCertificates(user_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/getCompletedCertificates/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCourseLevelsByCourseId(id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/courseLevels/'+id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCourseGamesByLevels(id, level, user_id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/courseGamesByLevelsForUser/'+id+'/'+level +'/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCourseVideos(id, user_id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getCourseVideosForUser/'+ id +'/'+user_id + '/' + language_id )
      .map((res: any)=>res)
  }

  getCourseResources(id, user_id, language_id){
    return this.http.get(Configuration.ServerWithApiUrl + '/getCourseResourcesForUser/'+ id +'/'+user_id + '/' + language_id )
      .map((res: any)=>res)
  }

  getCertInLicense(data){

    return this.http.post(Configuration.ServerWithApiUrl + '/getCertInLicense', data)
      .map((res: any)=>res)
  }

  getJourneyPlayedDetails(id, user_id, language_id){
    return this.http.get(Configuration.ServerWithApiUrl + '/getJourneyForUser/'+ id +'/'+user_id + '/' + language_id )
      .map((res: any)=>res)
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/score-card.service.ts